module.exports = __webpack_public_path__ + "static/media/home.a1cc9622.md";


//////////////////
// WEBPACK FOOTER
// ./src/markdown/home.md
// module id = 331
// module chunks = 0